<template>
  <div v-loading="submitLoading" class="app-container">
    <el-form ref="ruleForm" :rules="rules" :model="temp" label-width="150px">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane v-if="temp.baseinfo" label="基本信息" name="first" class="tabpane">
          <el-form-item label="贷款类型" prop="baseinfo.loan_type">
            <el-radio-group v-model="temp.baseinfo.loan_type">
              <el-radio size="medium" :label="1">企业贷款</el-radio>
              <el-radio size="medium" :label="2">个人贷款</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="temp.baseinfo.loan_type === 1" label="贷款企业" prop="baseinfo.enterprise_name">
            <el-input v-model="temp.baseinfo.enterprise_name" style="max-width:500px;" maxlength="20" show-word-limit></el-input>
          </el-form-item>
          <el-form-item v-if="temp.baseinfo.loan_type === 1" label="企业电话" prop="baseinfo.enterprise_phone">
            <el-input v-model="temp.baseinfo.enterprise_phone" style="max-width:500px;"></el-input>
          </el-form-item>
          <el-form-item :label="temp.baseinfo.loan_type === 1?'负责人征信':'申请人征信'" prop="baseinfo.credit_investigation">
            <el-radio-group v-if="dictionary.applicant_credit_investigation" v-model="temp.baseinfo.credit_investigation">
              <el-radio v-for="(item,index) in dictionary.applicant_credit_investigation" :key="index" size="medium" :label="Number(item.value)">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="temp.baseinfo.loan_type === 1?'负责人姓名':'申请人姓名'" prop="baseinfo.name">
            <el-input v-model="temp.baseinfo.name" style="max-width:500px;" maxlength="20" show-word-limit></el-input>
          </el-form-item>
          <el-form-item :label="temp.baseinfo.loan_type === 1?'负责人电话':'申请人电话'" prop="baseinfo.phone">
            <el-input v-model="temp.baseinfo.phone" :disabled="baseinfoPhoneDisabled" style="max-width:500px;"></el-input>
          </el-form-item>
          <el-form-item label="婚姻状况" prop="baseinfo.marriage">
            <!-- <el-radio-group v-if="dictionary.marital_status" v-model="temp.baseinfo.marriage">
              <el-radio v-for="(item,index) in dictionary.marital_status" :key="index" size="medium" :label="Number(item.value)">{{ item.label }}</el-radio>
            </el-radio-group> -->
            <el-radio-group v-if="dictionary.marital_status" v-model="temp.baseinfo.marriage">
              <el-radio size="medium" :label="1">已婚</el-radio>
              <el-radio size="medium" :label="2">未婚</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="temp.baseinfo.marriage === 1" label="结婚证明" prop="baseinfo.marriage_certificate">
            <FileList v-model="temp.baseinfo.marriage_certificate" :limit="9"></FileList>
          </el-form-item>
          <el-form-item v-if="temp.baseinfo.marriage === 1" label="配偶姓名" prop="baseinfo.spouse_name">
            <el-input v-model="temp.baseinfo.spouse_name" style="max-width:500px;" maxlength="20" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="有无子女" prop="baseinfo.is_have_children">
            <el-radio-group v-model="temp.baseinfo.is_have_children">
              <el-radio size="medium" :label="1">有</el-radio>
              <el-radio size="medium" :label="2">无</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="temp.baseinfo.is_have_children === 1" label="子女情况" prop="baseinfo.children_info">
            <el-radio-group v-if="dictionary.children_situation" v-model="temp.baseinfo.children_info">
              <el-radio v-for="(item,index) in dictionary.children_situation" :key="index" size="medium" :label="Number(item.value)">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="temp.baseinfo.loan_type === 1?'负责人身份证信息':'申请人身份证信息'" prop="baseinfo.id_card">
            <el-descriptions title="" direction="vertical" style="width:500px;" border :label-style="{textAlign:'center'}" :content-style="{textAlign:'center'}">
              <el-descriptions-item label="身份证正面">
                <FileList v-model="temp.baseinfo.id_card_positive" :limit="1"></FileList>
              </el-descriptions-item>
              <el-descriptions-item label="身份证反面">
                <FileList v-model="temp.baseinfo.id_card_reverse" :limit="1"></FileList>
              </el-descriptions-item>
            </el-descriptions>
          </el-form-item>
          <el-form-item v-if="temp.baseinfo.marriage === 1" label="配偶身份证信息" prop="baseinfo.spouse_id_card">
            <el-descriptions title="" direction="vertical" style="width:500px;" border :label-style="{textAlign:'center'}" :content-style="{textAlign:'center'}">
              <el-descriptions-item label="身份证正面">
                <FileList v-model="temp.baseinfo.spouse_id_card_positive" :limit="1"></FileList>
              </el-descriptions-item>
              <el-descriptions-item label="身份证反面">
                <FileList v-model="temp.baseinfo.spouse_id_card_reverse" :limit="1"></FileList>
              </el-descriptions-item>
            </el-descriptions>
          </el-form-item>
          <el-form-item label="户口本信息" prop="baseinfo.household_register">
            <FileList v-model="temp.baseinfo.household_register" :limit="9"></FileList>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="紧急联系人" name="second" class="tabpane">
          <el-form-item prop="contact">
            <el-table v-if="temp.contact" :data="temp.contact" border style="width: 750px">
              <el-table-column prop="relationship" align="center" label="所属关系" width="300">
                <template slot-scope="scope">
                  <el-select v-if="dictionary.family_ties" v-model="scope.row.relationship" placeholder="请选择" style="width:100%;">
                    <el-option v-for="(item,index) in dictionary.family_ties" :key="index" :label="item.label" :value="Number(item.value)"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="phone" align="center" label="联系电话" width="300">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.phone" placeholder="请输入联系人电话"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button v-if="scope.$index === 0" type="primary" icon="el-icon-plus" circle @click="contactAdd('contact')"></el-button>
                  <el-button v-else type="danger" icon="el-icon-delete" circle @click="contactDel('contact',scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane v-if="temp.baseinfo.loan_type === 1" label="企业信息" name="qiye" class="tabpane">
          <el-form-item label="企业性质" prop="enterprise.nature">
            <el-radio-group v-if="dictionary.enterprise_nature" v-model="temp.enterprise.nature">
              <el-radio v-for="(item,index) in dictionary.enterprise_nature" :key="index" size="medium" :label="Number(item.value)">{{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="企业名称" prop="enterprise.name">
            <el-input v-model="temp.enterprise.name" style="max-width:500px;" maxlength="20" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="企业经营年限" prop="enterprise.operating_life">
            <el-input-number v-model="temp.enterprise.operating_life" :min="0" :controls="false"></el-input-number> 年
          </el-form-item>
          <el-form-item label="企业税号" prop="enterprise.duty_paragraph">
            <el-input v-model="temp.enterprise.duty_paragraph" style="max-width:500px;"></el-input>
          </el-form-item>
          <el-form-item label="企业法人" prop="enterprise.legal_person">
            <el-input v-model="temp.enterprise.legal_person" style="max-width:500px;"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证信息" prop="enterprise.id_card">
            <el-descriptions title="" direction="vertical" style="width:500px;" border :label-style="{textAlign:'center'}" :content-style="{textAlign:'center'}">
              <el-descriptions-item label="身份证正面">
                <FileList v-model="temp.enterprise.id_card_positive" :limit="1"></FileList>
              </el-descriptions-item>
              <el-descriptions-item label="身份证反面">
                <FileList v-model="temp.enterprise.id_card_reverse" :limit="1"></FileList>
              </el-descriptions-item>
            </el-descriptions>
          </el-form-item>
          <el-form-item label="养殖场地址" prop="enterprise.addr">
            <el-cascader v-model="enterprise_address" :options="cityOptions" style="min-width:300px;" @change="enterpriseAddressChange"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="enterprise.address">
            <el-input v-model="temp.enterprise.address" style="max-width:500px;"></el-input>
          </el-form-item>
          <el-form-item label="企业营业执照信息" prop="enterprise.licence">
            <FileList v-model="temp.enterprise.licence" :limit="9"></FileList>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="活畜信息" name="third" class="tabpane">
          <el-alert title="活畜信息" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-form-item label="养殖场地址" prop="animal_base.addr">
            <el-cascader v-model="address" :options="cityOptions" style="min-width:300px;" @change="addressChange"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="animal_base.address">
            <el-input v-model="temp.animal_base.address" style="max-width:500px;" maxlength="100" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="养殖经验" prop="animal_base.experience">
            <el-input-number v-model="temp.animal_base.experience" :min="1" :controls="false">
            </el-input-number> 年
          </el-form-item>
          <el-form-item label="有无称重称" prop="animal_base.is_weight">
            <el-radio-group v-model="temp.animal_base.is_weight">
              <el-radio size="medium" :label="1">有</el-radio>
              <el-radio size="medium" :label="2">无</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="养殖活畜">
            <el-card v-for="(animal,index) in temp.animal" :key="index" class="box-card" shadow="hover" style="margin-right:50px;position:relative;">
              <el-button v-if="index>0" type="danger" icon="el-icon-delete" circle style="position:absolute;top:10px;right:10px;" @click="contactDel('animal',index)">删除</el-button>
              <el-button v-if="index>0" type="danger" icon="el-icon-delete" circle style="position:absolute;bottom:10px;right:10px;" @click="contactDel('animal',index)">删除</el-button>
              <el-form-item label="活畜类型" :prop="'animal.'+index+'.animal_type'">
                <el-select v-model="animal.animal_type" placeholder="请选择" style="margin-right:20px;" @change="animalTypeChange($event,index)">
                  <el-option
                    v-for="item in animalType"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="活畜数量" :prop="'animal.'+index+'.animal_num'">
                <el-input-number v-model="animal.animal_num" :min="1" :controls="false">
                </el-input-number> {{ animal.animal_type_info.unit }}
              </el-form-item>
              <el-form-item label="养殖方式" :prop="'animal.'+index+'.breeding_method'">
                <el-radio-group v-if="dictionary.breeding_method" v-model="animal.breeding_method">
                  <el-radio v-for="(item,bmindex) in dictionary.breeding_method" :key="bmindex" size="medium" :label="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="养殖模式" :prop="'animal.'+index+'.breeding_mode'">
                <el-checkbox-group v-if="dictionary.breeding_mode" v-model="animal.breeding_mode">
                  <el-checkbox v-for="(item,bmindex) in dictionary.breeding_mode" :key="bmindex" size="medium" :label="item.value">{{ item.label }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-divider v-if="animal.animal_type.indexOf(1) !== -1" content-position="left" style="margin: 35px 0;">
                <div style="font-size:15px;font-weight: bold;">繁育母{{ animal.animal_type_info.name }}品种及规模</div>
              </el-divider>

              <template>

              </template>

              <el-divider v-if="animal.animal_type" content-position="left" style="margin: 35px 0;"><div style="font-size:15px;font-weight: bold;">母{{ animal.animal_type_info.name }}品种及规模</div></el-divider>

              <el-form-item v-if="animal.animal_type" :label="'2岁以上基础母'+animal.animal_type_info.name+'总数'" label-width="150" :prop="'animal.'+index+'.small_female_num'">
                <el-input-number v-model="animal.small_female_num" :min="1" :controls="false">
                </el-input-number> {{ animal.animal_type_info.unit }}
              </el-form-item>
              <el-form-item v-if="animal.animal_type" :prop="'animal.'+index+'.animal_female'">
                <el-table v-if="animal.animal_type" :data="animal.animal_female" border style="width: 700px">
                  <el-table-column prop="relationship" align="center" label="品种" width="300">
                    <template slot-scope="scope">
                      <el-select v-if="filteredAnimalKind(animal.animal_type)" v-model="scope.row.type" placeholder="请选择" style="width:100%;">
                        <el-option v-for="(item,akindex) in filteredAnimalKind(animal.animal_type)" :key="akindex" :label="item.name" :value="item.id+''"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="phone" align="center" label="数量" width="270">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.num" :min="1" :controls="false"></el-input-number> {{ animal.animal_type_info.unit }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button v-if="scope.$index === 0" type="primary" icon="el-icon-plus" circle @click="contactAdd('animal_female',index)"></el-button>
                      <el-button v-else type="danger" icon="el-icon-delete" circle @click="contactDel('animal_female',scope.$index,index)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-divider v-if="animal.animal_type" content-position="left"><div style="font-size:15px;font-weight: bold;">其他</div></el-divider>
              <el-form-item v-if="animal.animal_type" :label="'育肥公'+animal.animal_type_info.name+'总数'" :prop="'animal.'+index+'.male_num'">
                <el-input-number v-model="animal.male_num" :min="0" :controls="false">
                </el-input-number> {{ animal.animal_type_info.unit }}
              </el-form-item>
              <el-form-item v-if="animal.animal_type" :label="'现有'+animal.animal_type_info.small_name+'(2岁以下)'" :prop="'animal.'+index+'.small_num'">
                <el-input-number v-model="animal.small_num" :min="0" :controls="false">
                </el-input-number> {{ animal.animal_type_info.unit }}
              </el-form-item>
              <el-form-item v-if="animal.animal_type" label="生产率" :prop="'animal.'+index+'.efficiency'">
                <el-input-number v-model="animal.efficiency" :min="0" :max="100" :controls="false">
                </el-input-number> %
              </el-form-item>
              <el-form-item v-if="animal.animal_type" label="死亡率" :prop="'animal.'+index+'.mortality_rate'">
                <el-input-number v-model="animal.mortality_rate" :min="0" :max="100" :controls="false">
                </el-input-number> %
              </el-form-item>

              <el-form-item v-if="animal.animal_type" label="是否上保险" :prop="'animal.'+index+'.is_insurance'">
                <el-radio-group v-model="animal.is_insurance">
                  <el-radio size="medium" :label="1">是</el-radio>
                  <el-radio size="medium" :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="animal.animal_type && animal.is_insurance === 1" label="保额" :prop="'animal.'+index+'.coverage'">
                <el-input-number v-model="animal.coverage" :min="0" :controls="false">
                </el-input-number> 元/{{ animal.animal_type_info.unit }}
              </el-form-item>
              <el-form-item v-if="animal.animal_type && animal.is_insurance === 1" label="保险单上传" :prop="'animal.'+index+'.insurance_policy'">
                <FileList v-model="animal.insurance_policy" :limit="9"></FileList>
              </el-form-item>
              <el-form-item v-if="animal.animal_type" label="是否防疫" :prop="'animal.'+index+'.is_prevent_epidemics'">
                <el-radio-group v-model="animal.is_prevent_epidemics">
                  <el-radio size="medium" :label="1">是</el-radio>
                  <el-radio size="medium" :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="animal.animal_type && animal.is_prevent_epidemics === 1" label="防疫记录本" :prop="'animal.'+index+'.pe_record'">
                <FileList v-model="animal.pe_record" :limit="9"></FileList>
              </el-form-item>
              <el-form-item v-if="animal.animal_type && animal.is_prevent_epidemics === 1" label="检疫证明" :prop="'animal.'+index+'.pe_certificate'">
                <FileList v-model="animal.pe_certificate" :limit="9"></FileList>
              </el-form-item>

              <el-divider v-if="animal.animal_type" content-position="left"><div style="font-size:15px;font-weight: bold;">{{ animal.animal_type_info.individual_name }}证明</div></el-divider>
              <el-form-item v-if="animal.animal_type" label="交易记录" :prop="'animal.'+index+'.trade_records'">
                <FileList v-model="animal.trade_records" :limit="9"></FileList>
              </el-form-item>
              <el-form-item v-if="animal.animal_type" label="村镇证明" :prop="'animal.'+index+'.town_certificate'">
                <FileList v-model="animal.town_certificate" :limit="9"></FileList>
              </el-form-item>
              <el-form-item v-if="animal.animal_type" label="出栏时间" :prop="'animal.'+index+'.slaughter_time'">
                <el-input-number v-model="animal.slaughter_time" :min="0" :controls="false">
                </el-input-number> 月
              </el-form-item>
            </el-card>
            <el-button type="primary" plain style="display:block;width:50%;max-width: 500px;margin:20px auto;" @click="contactAdd('animal')">增加</el-button>
          </el-form-item>
          <el-alert title="饲草料储备信息" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-card v-for="(fodder,index) in temp.fodder" :key="index" class="box-card" shadow="hover" style="margin-right:50px;position:relative;padding-right:100px;">
            <el-row>
              <el-col :span="8">
                <el-form-item :prop="'fodder.'+index+'.type'" style="margin:0;" label-width="0">
                  <el-select v-model="fodder.type" placeholder="请选择" style="margin-right:20px;" @change="fodderChange($event,index)">
                    <el-option v-for="item in fodderList" :key="item.id" :label="item.name" :value="item.id+''"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :prop="'fodder.'+index+'.weight'" style="margin:0;" label-width="0">
                  <el-input-number v-model="fodder.weight" :min="0" :controls="false">
                  </el-input-number> 吨
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item :prop="'fodder.'+index+'.kind'" style="margin:0;" label-width="0">
              <el-checkbox-group v-if="fodder.childrenList && fodder.childrenList.length>0" v-model="fodder.kind" style="margin-top:16px;">
                <el-checkbox v-for="children in fodder.childrenList" :key="children.id" :label="children.id">{{ children.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-button v-if="index>0" type="danger" icon="el-icon-delete" circle style="position:absolute;bottom:10px;right:10px;" @click="contactDel('fodder',index)">删除</el-button>
          </el-card>
          <el-button type="primary" plain style="display:block;width:50%;max-width: 500px;margin:20px auto;" @click="contactAdd('fodder')">增加</el-button>
          <el-alert title="备注信息" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>

          <el-form-item prop="remark" style="margin:0;" label-width="0">
            <el-input
              v-model="temp.animal_base.remark"
              resize="none"
              type="textarea"
              :rows="5"
              placeholder="请输入备注信息"
              style="width:90%;"
              maxlength="255"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="贷款信息" name="fourth" class="tabpane">
          <el-alert title="贷款信息" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-form-item label="贷款金额" prop="loan.loan_money">
            <el-input-number v-model="temp.loan.loan_money" :min="0" :controls="false"></el-input-number> 万元
          </el-form-item>
          <el-form-item label="贷款期限" prop="loan.loan_deadline">
            <el-select v-if="dictionary.length_of_maturity" v-model="temp.loan.loan_deadline" placeholder="请选择">
              <el-option v-for="(item,index) in dictionary.length_of_maturity" :key="index" :label="item.label" :value="Number(item.value)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="委托银行" prop="loan.entrust_bank">
            <el-select v-if="bankList" v-model="temp.loan.entrust_bank" placeholder="请选择">
              <el-option v-for="(item,blindex) in bankList" :key="blindex" :label="item.bank_name" :value="Number(item.id)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="贷款用途" prop="loan.loan_use">
            <el-checkbox-group v-if="dictionary.live_animals_loan_purposes" v-model="temp.loan.loan_use">
              <el-checkbox v-for="(item,bmindex) in dictionary.live_animals_loan_purposes" :key="bmindex" size="medium" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-alert title="负债情况" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-form-item label="负债金额" prop="loan.debt_money">
            <el-input-number v-model="temp.loan.debt_money" :min="0" :controls="false"></el-input-number> 万元
          </el-form-item>
          <el-form-item label="备注" prop="loan.debt_remark">
            <el-input v-model="temp.loan.debt_remark" resize="none" type="textarea" :rows="3" placeholder="请输入备注信息" style="width:90%;" maxlength="255" show-word-limit></el-input>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="资产信息" name="fifth" class="tabpane">
          <el-alert title="草场" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-form-item label="草场信息" prop="assets.grassland_type">
            <el-radio-group v-model="temp.assets.grassland_type">
              <el-radio size="medium" :label="1">自有</el-radio>
              <el-radio size="medium" :label="2">租赁</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="草场规模" prop="assets.grassland_mode">
            <el-input-number v-model="temp.assets.grassland_mode" :min="0" :controls="false"></el-input-number> 亩
          </el-form-item>
          <el-form-item label="草场证明" prop="assets.grassland_certificate">
            <FileList v-model="temp.assets.grassland_certificate" :limit="9"></FileList>
          </el-form-item>

          <el-alert title="棚圈" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-form-item label="棚圈信息" prop="assets.shed_type">
            <el-radio-group v-model="temp.assets.shed_type">
              <el-radio size="medium" :label="1">自建</el-radio>
              <el-radio size="medium" :label="2">租用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="棚圈规模" prop="assets.shed_mode">
            <el-input-number v-model="temp.assets.shed_mode" :min="0" :controls="false"></el-input-number> 平米
          </el-form-item>
          <el-form-item label="棚圈建设情况（照片+视频）" prop="assets.grassland_build">
            <FileList v-model="temp.assets.grassland_build" :limit="9" type="img_video"></FileList>
          </el-form-item>

          <el-alert title="房屋" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-form-item label="房屋信息" prop="assets.room_type">
            <el-radio-group v-model="temp.assets.room_type">
              <el-radio size="medium" :label="1">自建</el-radio>
              <el-radio size="medium" :label="2">租用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="房屋面积" prop="assets.room_area">
            <el-input-number v-model="temp.assets.room_area" :min="0" :controls="false"></el-input-number> 平米
          </el-form-item>
          <el-form-item label="房产证信息" prop="assets.room_certificate">
            <FileList v-model="temp.assets.room_certificate" :limit="9"></FileList>
          </el-form-item>
          <el-form-item label="房屋建设情况（照片+视频）" prop="assets.room_image">
            <FileList v-model="temp.assets.room_image" :limit="9" type="img_video"></FileList>
          </el-form-item>

          <el-alert title="机械设备" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-form-item label="设备信息" prop="assets.equipment_type">
            <el-radio-group v-model="temp.assets.equipment_type">
              <el-radio size="medium" :label="1">自有</el-radio>
              <el-radio size="medium" :label="2">租用</el-radio>
              <el-radio size="medium" :label="3">无</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="temp.assets.equipment_type===1 || temp.assets.equipment_type===2" label="农牧机械设备情况（照片+视频）" prop="assets.equipment_image">
            <FileList v-model="temp.assets.equipment_image" :limit="9" type="img_video"></FileList>
          </el-form-item>

          <el-alert title="车辆" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-form-item label="车辆信息" prop="assets.car_type">
            <el-radio-group v-model="temp.assets.car_type">
              <el-radio size="medium" :label="1">自有</el-radio>
              <el-radio size="medium" :label="2">无</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="temp.assets.car_type===1" label="车辆情况（照片+视频）" prop="assets.car_image">
            <FileList v-model="temp.assets.car_image" :limit="9" type="img_video"></FileList>
          </el-form-item>

          <el-alert title="其他固定资产价值" type="success" :closable="false" style="color:#409EFF;background: rgb(198, 226, 255);margin:5px 0 20px 0;"></el-alert>
          <el-form-item label="" prop="assets.other_assets" label-width="0">
            <el-input v-model="temp.assets.other_assets" resize="none" type="textarea" :rows="3" placeholder="请输入其他固定资产价值" style="width:90%;" maxlength="255" show-word-limit></el-input>
          </el-form-item>

        </el-tab-pane>
        <el-tab-pane label="收入支出信息" name="sixth" class="tabpane">
          <el-form-item label="近两年牛犊销售情况" prop="assets.sell_type">
            <el-radio-group v-if="dictionary.sales_status" v-model="temp.assets.sell_type">
              <el-radio v-for="(item,bmindex) in dictionary.sales_status" :key="bmindex" size="medium" :label="Number(item.value)">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="second_year" prop="assets.two_year_before">
            <el-input-number v-model="temp.assets.two_year_before" :controls="false">
            </el-input-number> 万元
          </el-form-item>
          <el-form-item :label="first_year" prop="assets.one_year_before">
            <el-input-number v-model="temp.assets.one_year_before" :controls="false">
            </el-input-number> 万元
          </el-form-item>
          <el-form-item label="本年预计养殖支出" prop="assets.expenses">
            <el-table :data="temp.assets.expenses" style="width: 700px" border>
              <el-table-column prop="type" label="支出类型" align="center" width="300">
                <template slot-scope="scope">
                  <el-select v-if="dictionary.aquaculture_expenditure_type" v-model="scope.row.type" placeholder="请选择" style="width: 100%">
                    <el-option v-for="(item,index) in dictionary.aquaculture_expenditure_type" :key="index" :label="item.label" :value="Number(item.value)"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="支出金额" align="center" width="270">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.money" :controls="false"></el-input-number> 万元
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button v-if="scope.$index === 0" type="primary" icon="el-icon-plus" circle @click="contactAdd('expenses')"></el-button>
                  <el-button v-else type="danger" icon="el-icon-delete" circle @click="contactDel('expenses',scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="本年预计养殖收入" prop="assets.breed_income">
            <el-input-number v-model="temp.assets.breed_income" :controls="false"></el-input-number> 万元
          </el-form-item>
          <el-form-item label="其它产业/工作收入" prop="assets.other_income">
            <el-input-number v-model="temp.assets.other_income" :controls="false">
            </el-input-number> 万元
          </el-form-item>
          <el-form-item label="本年预计其它收益" prop="assets.other_profit">
            <el-input-number v-model="temp.assets.other_profit" :controls="false">
            </el-input-number> 万元
          </el-form-item>
          <el-form-item label="是否为公职人员" prop="assets.civil_servant">
            <el-radio-group v-model="temp.assets.civil_servant">
              <el-radio size="medium" :label="1">是</el-radio>
              <el-radio size="medium" :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="监管信息" name="seventh" class="tabpane">
          <el-form-item label="监控设备" prop="space.monitor">
            <el-radio-group v-model="temp.space.monitor">
              <el-radio size="medium" :label="1">有</el-radio>
              <el-radio size="medium" :label="2">无</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="品牌" prop="space.brand">
            <el-select v-if="dictionary.monitor_brand" v-model="temp.space.brand" placeholder="请选择">
              <el-option v-for="(item,index) in dictionary.monitor_brand" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="网络状况" prop="space.network">
            <el-radio-group v-if="dictionary.network_status" v-model="temp.space.network">
              <el-radio v-for="(item,bmindex) in dictionary.network_status" :key="bmindex" size="medium" :label="Number(item.value)">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="牛劲夹栏" prop="space.hurdle">
            <el-radio-group v-model="temp.space.hurdle">
              <el-radio size="medium" :label="1">有</el-radio>
              <el-radio size="medium" :label="2">无</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="养殖方式" prop="space.breeding_mode">
            <el-checkbox-group v-if="dictionary.seasonal_culture_method && temp.space.breeding_mode" v-model="temp.space.breeding_mode">
              <el-checkbox v-for="(item,scmindex) in dictionary.seasonal_culture_method" :key="scmindex" size="medium" :label="item.value+''">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="是否转场" prop="space.is_transfer">
            <el-radio-group v-model="temp.space.is_transfer">
              <el-radio size="medium" :label="1">是</el-radio>
              <el-radio size="medium" :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="现场照片" prop="space.image">
            <FileList v-model="temp.space.image" :limit="9"></FileList>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <div class="footer">
      <div class="shadow"></div>
      <el-button type="info" plain @click="cancal()">取消</el-button>
      <el-button type="primary" @click="submit()">提交</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/api/customer/herdsman' // 和数据交互相关写在api 方便复用
import indexApi from '@/api/index' // 和数据交互相关写在api 方便复用
import animalApi from '@/api/baseset/animal' // 和数据交互相关写在api 方便复用
import animalVarietyApi from '@/api/baseset/animal_variety' // 和数据交互相关写在api 方便复用
import fodderApi from '@/api/baseset/fodder' // 和数据交互相关写在api 方便复用
import bankApi from '@/api/bank_info' // 和数据交互相关写在api 方便复用
import dict_data from '@/api/system/dict_data'
import FileList from '@/components/attachment/FileList'

export default {
  name: 'HerdsmanEdit',
  components: { FileList },
  // 列绑定格式化器
  filters: {
  },
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      temp: {},
      baseinfoPhoneDisabled: false,
      activeName: 'fifth',
      dictionary: {
      },
      cityOptions: [],
      address: [],
      enterprise_address: [],
      animalType: [],
      animalKind: [],
      fodderList: [],
      bankList: [],
      first_year: '',
      second_year: '',
      submitLoading: false,
      rules: {
        baseinfo: {
          loan_type: [{ required: true, message: '请选择贷款类型', trigger: ['blur', 'change'] }],
          enterprise_name: [{ required: true, validator: (rule, value, callback) => {
            if (this.temp.baseinfo.loan_type === 1) {
              if (!value) {
                callback(new Error('请填写贷款企业'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          enterprise_phone: [{ required: true, validator: (rule, value, callback) => {
            if (this.temp.baseinfo.loan_type === 1) {
              if (!value) {
                callback(new Error('请填写企业电话'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          credit_investigation: [{ required: true, validator: (rule, value, callback) => {
            if (!value) {
              if (this.temp.baseinfo.loan_type === 1) {
                callback(new Error('请选择负责人征信'))
              } else {
                callback(new Error('请选择申请人征信'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          name: [{ required: true, validator: (rule, value, callback) => {
            if (!value) {
              if (this.temp.baseinfo.loan_type === 1) {
                callback(new Error('请填写负责人姓名'))
              } else {
                callback(new Error('请填写申请人姓名'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          phone: [{ required: true, validator: (rule, value, callback) => {
            if (!value) {
              if (this.temp.baseinfo.loan_type === 1) {
                callback(new Error('请填写负责人电话'))
              } else {
                callback(new Error('请填写申请人电话'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          marriage: [{ required: true, message: '请选择婚姻状况', trigger: ['blur', 'change'] }],
          marriage_certificate: [{ required: true, validator: (rule, value, callback) => {
            if (this.temp.baseinfo.marriage === 1) {
              if (!value) {
                callback(new Error('请上传结婚证明'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          spouse_name: [{ required: true, validator: (rule, value, callback) => {
            if (this.temp.baseinfo.marriage === 1) {
              if (!value) {
                callback(new Error('请填写配偶姓名'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          is_have_children: [{ required: true, message: '请选择有无子女', trigger: 'change' }],
          children_info: [{ required: true, validator: (rule, value, callback) => {
            if (this.temp.baseinfo.is_have_children === 1) {
              if (!value) {
                callback(new Error('请选择子女情况'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          id_card: [{ required: true, validator: (rule, value, callback) => {
            if (!this.temp.baseinfo.id_card_positive) {
              if (this.temp.baseinfo.loan_type === 1) {
                callback(new Error('请上传负责人身份证信息（正面）'))
              } else {
                callback(new Error('请上传申请人身份证信息（正面）'))
              }
            } else if (!this.temp.baseinfo.id_card_reverse) {
              if (this.temp.baseinfo.loan_type === 1) {
                callback(new Error('请上传负责人身份证信息（背面）'))
              } else {
                callback(new Error('请上传申请人身份证信息（背面）'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          spouse_id_card: [{ required: true, validator: (rule, value, callback) => {
            if (this.temp.baseinfo.marriage === 1) {
              if (!this.temp.baseinfo.spouse_id_card_positive || !this.temp.baseinfo.spouse_id_card_reverse) {
                callback(new Error('请上传配偶身份证信息'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          household_register: [{ required: true, message: '请上传户口本信息', trigger: 'change' }]
        },
        contact: [{ required: true, trigger: ['blur', 'change'], validator: (rule, value, callback) => {
          if (this.temp.contact.length < 1) {
            callback(new Error('请添加紧急联系人'))
          } else {
            for (let i = 0; i < this.temp.contact.length; i++) {
              if (!this.temp.contact[i].relationship || !this.temp.contact[i].phone) {
                callback(new Error('紧急联系人信息填写有误'))
              }
            }
          }
          callback()
        } }],
        enterprise: {
          nature: [{ required: true, message: '请选择企业性质', trigger: ['blur', 'change'] }],
          name: [{ required: true, message: '请输入企业名称', trigger: ['blur', 'change'] }],
          operating_life: [{ required: true, message: '请输入企业经营年限', trigger: ['blur', 'change'] }],
          duty_paragraph: [{ required: true, message: '请输入企业税号', trigger: ['blur', 'change'] }],
          legal_person: [{ required: true, message: '请输入企业法人', trigger: ['blur', 'change'] }],
          id_card: [{ required: true, validator: (rule, value, callback) => {
            if (!this.temp.enterprise.id_card_positive) {
              callback(new Error('请上传法人身份证信息（正面）'))
            } else if (!this.temp.enterprise.id_card_reverse) {
              callback(new Error('请上传法人身份证信息（背面）'))
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          addr: [{ required: true, validator: (rule, value, callback) => {
            if (!this.temp.enterprise.province || !this.temp.enterprise.city || !this.temp.enterprise.district) {
              callback(new Error('请选择养殖场地址'))
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          address: [{ required: true, message: '请输入详细地址', trigger: ['blur', 'change'] }],
          licence: [{ required: true, message: '请上传企业营业执照信息', trigger: ['blur', 'change'] }]
        },
        animal_base: {
          addr: [{ required: true, validator: (rule, value, callback) => {
            if (!this.temp.animal_base.province || !this.temp.animal_base.city || !this.temp.animal_base.district) {
              callback(new Error('请选择养殖场地址'))
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          address: [{ required: true, message: '请填写养殖场详细地址', trigger: ['blur', 'change'] }],
          experience: [{ required: true, message: '请填写养殖经验', trigger: ['blur', 'change'] }]
        },
        animal: [],
        fodder: [],
        remark: [{ required: true, message: '请输入备注信息', trigger: 'blur', validator: (rule, value, callback) => {
          if (!this.temp.animal_base.remark || this.temp.animal_base.remark === '' || this.temp.animal_base.remark === ' ') {
            callback('请输入备注信息')
          } else {
            callback()
          }
        } }],
        loan: {
          loan_money: [{ required: true, message: '请输入贷款金额', trigger: ['blur', 'change'] }],
          loan_deadline: [{ required: true, message: '请选择贷款期限', trigger: ['blur', 'change'] }],
          entrust_bank: [{ required: true, message: '请选择委托银行', trigger: ['blur', 'change'] }],
          loan_use: [{ required: true, message: '请选择贷款用途', trigger: ['blur', 'change'] }],
          debt_money: [{ required: true, message: '请选择负债金额', trigger: ['blur', 'change'] }],
          debt_remark: [{ required: true, message: '请选择备注', trigger: ['blur', 'change'] }]
        },
        assets: {
          grassland_type: [{ required: true, message: '请选择草场信息', trigger: ['blur', 'change'] }],
          grassland_mode: [{ required: true, message: '请输入草场规模', trigger: ['blur', 'change'] }],
          grassland_certificate: [{ required: true, message: '请上传草场证明', trigger: ['blur', 'change'] }],
          shed_type: [{ required: true, message: '请选择棚圈信息', trigger: ['blur', 'change'] }],
          shed_mode: [{ required: true, message: '请输入棚圈规模', trigger: ['blur', 'change'] }],
          grassland_build: [{ required: true, message: '请上传房屋建设情况', trigger: ['blur', 'change'] }],
          room_type: [{ required: true, message: '请选择房屋信息', trigger: ['blur', 'change'] }],
          room_area: [{ required: true, message: '请输入房屋面积', trigger: ['blur', 'change'] }],
          room_certificate: [{ required: true, message: '请上传房产证信息', trigger: ['blur', 'change'] }],
          room_image: [{ required: true, message: '请上传房屋建设情况', trigger: ['blur', 'change'] }],
          equipment_type: [{ required: true, message: '请选择设备信息', trigger: ['blur', 'change'] }],
          equipment_image: [{ required: true, validator: (rule, value, callback) => {
            if (this.temp.assets.equipment_type === 1 || this.temp.assets.equipment_type === 2) {
              if (!value) {
                callback(new Error('请上传农牧机械设备情况'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          car_type: [{ required: true, message: '请选择车辆信息', trigger: ['blur', 'change'] }],
          car_image: [{ required: true, validator: (rule, value, callback) => {
            if (this.temp.assets.car_type === 1) {
              if (!value) {
                callback(new Error('请上传车辆情况'))
              }
            }
            callback()
          }, trigger: ['blur', 'change'] }],
          other_assets: [{ required: true, message: '请输入其他固定资产价值', trigger: ['blur', 'change'] }],
          sell_type: [{ required: true, message: '请选择近两年牛犊销售情况', trigger: ['blur', 'change'] }],
          two_year_before: [{ required: true, trigger: ['blur', 'change'], validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入' + this.second_year + '销售情况'))
            }
            callback()
          } }],
          one_year_before: [{ required: true, trigger: ['blur', 'change'], validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入' + this.first_year + '销售情况'))
            }
            callback()
          } }],
          expenses: [{ required: true, trigger: ['blur', 'change'], validator: (rule, value, callback) => {
            if (this.temp.assets.expenses.length < 1) {
              callback(new Error('请添加本年预计养殖支出信息'))
            } else {
              for (let i = 0; i < this.temp.assets.expenses.length; i++) {
                if (!this.temp.assets.expenses[i].type || !this.temp.assets.expenses[i].money) {
                  callback(new Error('本年预计养殖支出信息填写有误'))
                }
              }
            }
            callback()
          } }],
          breed_income: [{ required: true, message: '请填写本年预计养殖收入', trigger: ['blur', 'change'] }],
          other_income: [{ required: true, message: '请填写其它产业', trigger: ['blur', 'change'] }],
          other_profit: [{ required: true, message: '请填写本年预计其它收益', trigger: ['blur', 'change'] }],
          civil_servant: [{ required: true, message: '请选择是否为公职人员', trigger: ['blur', 'change'] }]
        },
        space: {
          monitor: [{ required: true, message: '请选择监控设备', trigger: ['blur', 'change'] }],
          brand: [{ required: true, message: '请选择品牌', trigger: ['blur', 'change'] }],
          network: [{ required: true, message: '请选择网络状况', trigger: ['blur', 'change'] }],
          hurdle: [{ required: true, message: '请选择牛劲夹栏', trigger: ['blur', 'change'] }],
          breeding_mode: [{ required: true, message: '请选择监管信息-养殖方式', trigger: ['blur', 'change'] }],
          is_transfer: [{ required: true, message: '请选择是否转场', trigger: ['blur', 'change'] }],
          image: [{ required: true, message: '请上传现场照片', trigger: ['blur', 'change'] }]
        }

      }
    }
  },
  watch: {
    id() {
      this.resetTemp()
      this.getDetails()
    }
  },
  created() {
    this.setRules()
    this.resetTemp()
    dict_data.Drop({
      sort: 'sort', order: 'asc', isPaginator: false,
      dict_code: ['enterprise_nature', 'sales_status', 'monitor_brand', 'length_of_maturity', 'applicant_credit_investigation', 'marital_status', 'children_situation', 'breeding_method', 'breeding_mode', 'live_animals_loan_purposes', 'network_status', 'seasonal_culture_method', 'aquaculture_expenditure_type', 'family_ties']
    }).then(response => {
      this.dictionary = response.data
    })
    this.getArea()
    this.getAnimal()
    this.getAnimalKind()
    this.getFodder()
    this.getBankList()
    this.$nextTick(() => {
      this.getDetails()
    })
  },
  methods: {
    setRules() {
      const animal_rules = []
      if (this.temp.animal) {
        var num = this.temp.animal.length
        for (var i = 0; i < num; i++) {
          animal_rules.push(this.addToRulesAnimal(i))
        }
      }
      this.rules.animal = animal_rules

      const fodder_rules = []
      if (this.temp.fodder) {
        var num2 = this.temp.fodder.length
        for (var j = 0; j < num2; j++) {
          fodder_rules.push({
            'type': [{ required: true, message: '请选择饲草料类型', trigger: ['blur', 'change'] }],
            'weight': [{ required: true, message: '请填写饲草料重量', trigger: ['blur', 'change'] }],
            'kind': [{ required: true, message: '请选择饲草料品种', trigger: ['blur', 'change'] }]
          })
        }
      }
      this.rules.fodder = fodder_rules
    },
    addToRulesAnimal(index = null) {
      const animal_rules = {
        'animal_type': [{ required: true, message: '请选择活畜类型', trigger: ['blur', 'change'] }],
        'animal_num': [{ required: true, message: '请填写活畜数量', trigger: ['blur', 'change'] }],
        'breeding_method': [{ required: true, message: '请选择养殖方式', trigger: ['blur', 'change'] }],
        'breeding_mode': [{ required: true, message: '请选择养殖模式', trigger: ['blur', 'change'] }]
      }
      if (index != null && this.temp.animal[index]) {
        const animal_type_info = this.temp.animal[index].animal_type_info
        if (animal_type_info && Object.keys(animal_type_info).length > 0) {
          animal_rules['small_female_num'] = [{ required: true, message: '请填写2岁以上基础母' + animal_type_info.name + '总数', trigger: ['blur', 'change'] }]
          animal_rules['animal_female'] = [{ validator: function(rule, value, callback) {
            if (value.length < 1) {
              callback(new Error('至少填加至少一个母' + animal_type_info.name + '品种及规模'))
            } else {
              for (var j in value) {
                if (!value[j].type) {
                  callback(new Error('请选择母' + animal_type_info.name + '品种及规模”的品种'))
                } else if (!value[j].num) {
                  callback(new Error('请填写母' + animal_type_info.name + '品种及规模”的数量'))
                }
              }
              callback()
            }
          }, trigger: ['blur', 'change'] }]
          animal_rules['male_num'] = [{ required: true, message: '请填写育肥公' + animal_type_info.name + '总数', trigger: ['blur', 'change'] }]
          animal_rules['small_num'] = [{ required: true, message: '请填写现有' + animal_type_info.name + '(2岁以下)总数', trigger: ['blur', 'change'] }]
          animal_rules['efficiency'] = [{ required: true, message: '请填写生产率', trigger: ['blur', 'change'] }]
          animal_rules['mortality_rate'] = [{ required: true, message: '请填写死亡率', trigger: ['blur', 'change'] }]
          animal_rules['is_insurance'] = [{ required: true, message: '请选择是否上保险', trigger: ['blur', 'change'] }]
          animal_rules['coverage'] = [{ required: true, message: '请填写保额', trigger: ['blur', 'change'] }]
          animal_rules['insurance_policy'] = [{ required: true, message: '请上传保险单', trigger: ['blur', 'change'] }]
          animal_rules['is_prevent_epidemics'] = [{ required: true, message: '请选择是否防疫', trigger: ['blur', 'change'] }]
          animal_rules['pe_record'] = [{ required: true, message: '请上传防疫记录本', trigger: ['blur', 'change'] }]
          animal_rules['pe_certificate'] = [{ required: true, message: '请上传检疫证明', trigger: ['blur', 'change'] }]
          animal_rules['trade_records'] = [{ required: true, message: '请上传交易记录', trigger: ['blur', 'change'] }]
          animal_rules['town_certificate'] = [{ required: true, message: '请上传村镇证明', trigger: ['blur', 'change'] }]
          animal_rules['slaughter_time'] = [{ required: true, message: '请填写出栏时间', trigger: ['blur', 'change'] }]
        }
      }

      return animal_rules
    },
    filteredAnimalKind(animal_type) {
      return this.animalKind.filter(item => item.animal_id === animal_type)
    },
    submit() {
      this.$refs['ruleForm'].validate((valid, errors) => {
        if (valid) {
          if (this.submitLoading) {
            return
          }
          this.submitLoading = true
          api.Update(this.temp).then(response => {
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
            this.getDetails()
            this.submitLoading = false
          }).catch(() => {
            this.submitLoading = false
          })
        } else {
          this.formErrorMessage(errors)
        }
      })
    },
    // 根据表单验证，把错误提示拿出来，进行弹窗提示
    formErrorMessage(errors) {
      const errorKeys = Object.keys(errors) // 获取所有错误字段
      for (const key in this.rules) {
        let sonKey = []
        if (Array.isArray(this.rules[key]) && this.rules[key].length > 0) {
          if ((this.rules[key][0]['required'] || this.rules[key][0]['message'])) {
            if (errors[key]) {
              this.$message({ showClose: true, message: errors[key][0].message, type: 'warning' })
              return
            }
          } else {
            for (var b = 0; b < this.rules[key].length; b++) {
              sonKey = Object.keys(this.rules[key][b])
              for (var c in sonKey) {
                if (errorKeys.includes(key + '.' + b + '.' + sonKey[c])) {
                  this.$message({ showClose: true, message: errors[key + '.' + b + '.' + sonKey[c]][0].message, type: 'warning' })
                  return
                }
              }
            }
          }
        } else {
          sonKey = Object.keys(this.rules[key])
          for (var a in sonKey) {
            if (errorKeys.includes(key + '.' + sonKey[a])) {
              this.$message({ showClose: true, message: errors[key + '.' + sonKey[a]][0].message, type: 'warning' })
              return
            }
          }
        }
      }
      this.$message({ showClose: true, message: Object.values(errors)[0][0].message, type: 'warning' })
    },
    cancal() {
      this.$emit('close')
    },
    animalTypeChange(val, index) {
      this.temp.animal[index].animal_type_info = this.animalType.find(item => item.id === val)
      this.rules.animal[index] = this.addToRulesAnimal(index)
    },
    getBankList() {
      bankApi.Query({
        sort: 'order_no', order: 'asc', isPaginator: false,
        type: 3
      }).then(response => {
        this.bankList = response.data
      })
    },
    fodderChange(val, index) { // 饲料选择
      this.temp.fodder[index].childrenList = []
      fodderApi.Query({
        sort: 'order_no', order: 'asc', isPaginator: false,
        parent_id: val
      }).then(response => {
        this.$set(this.temp.fodder[index], 'childrenList', response.data)
      })
    },
    getFodder() { // 获取饲料
      fodderApi.Query({
        sort: 'order_no', order: 'asc', isPaginator: false
      }).then(response => {
        this.fodderList = response.data
      })
    },
    getAnimalKind() { // 获取动物品种
      animalVarietyApi.Query({
        sort: 'order_no', order: 'asc', isPaginator: false
      }).then(response => {
        this.animalKind = response.data
      })
    },
    getAnimal() { // 获取动物种类
      animalApi.Query({
        sort: 'order_no', order: 'asc', isPaginator: false
      }).then(response => {
        this.animalType = response.data
      })
    },
    getArea() { // 获取省市区
      indexApi.getAreaTree({}).then(response => {
        this.cityOptions = response.data
      })
    },
    addressChange(val) {
      this.temp.animal_base.province = val[0]
      this.temp.animal_base.city = val[1]
      this.temp.animal_base.district = val[2]
    },
    enterpriseAddressChange(val) {
      this.temp.enterprise.province = val[0]
      this.temp.enterprise.city = val[1]
      this.temp.enterprise.district = val[2]
    },
    contactAdd(type, parent_index = 0) {
      if (type === 'contact') { // 添加联系人
        this.temp.contact.push({
          relationship: '',
          phone: ''
        })
      } else if (type === 'animal_female') {
        this.temp.animal[parent_index].animal_female.push({
          relationship: '',
          phone: ''
        })
      } else if (type === 'animal') {
        this.temp.animal.push({
          animal_type: this.animalType[0].id,
          breeding_mode: [],
          animal_female: [{}],
          animal_type_info: this.animalType[0]
        })
      } else if (type === 'fodder') {
        this.temp.fodder.push({
          type: '',
          weight: 0,
          kind: [],
          childrenList: []
        })
      } else if (type === 'expenses') {
        this.temp.assets.expenses.push({
          type: '',
          money: 0
        })
      }
      this.setRules()
    },
    contactDel(type, index, parent_index = 0) {
      if (type === 'animal_female') {
        this.temp.animal[parent_index].animal_female.splice(index, 1)
        this.rules.animal[parent_index][type].splice(index, 1)
      } else if (type === 'expenses') {
        this.temp.assets.expenses[type].splice(index, 1)
        this.rules.assets.expenses[type].splice(index, 1)
      } else {
        this.temp[type].splice(index, 1)
        this.rules[type].splice(index, 1)
      }
    },
    getDetails() { // 获取详情
      api.Detail(this.id).then(response => {
        if (response.data) {
          this.baseinfoPhoneDisabled = true
          const data = response.data
          // 初始化 contact 字段
          if (!data.contact || !Array.isArray(data.contact)) data.contact = [{}]
          // 初始化 animal 字段
          console.log(data.animal, '------------------')
          if (!data.animal || !Array.isArray(data.animal)) {
            data.animal = [
              {
                breeding_mode: [],
                is_insurance: 1,
                is_prevent_epidemics: 1,
                breed: [],
                fatten: [],
                other: [],
                animal_type_info: {}
              }
            ]
          }
          // 初始化 fodder 字段
          if (!data.fodder || !Array.isArray(data.fodder)) data.fodder = [{ kind: [], childrenList: [] }]
          // 初始化 fodder 字段
          if (!data.loan) data.loan = [{ loan_use: [] }]
          if (!data.enterprise) {
            data.enterprise = {}
          } else {
            this.enterprise_address = [response.data.enterprise.province + '', response.data.enterprise.city + '', response.data.enterprise.district + '']
          }
          // 初始化 expenses 字段
          if (!data.assets) {
            data.assets = { expenses: [{}] }
          }
          if (!data.space) {
            data.space = { breeding_mode: [] }
          }
          this.temp = response.data
          const year = response.data.create_time.substring(0, 4)
          this.first_year = (year - 1) + ''
          this.second_year = (year - 2) + ''
          this.address = [response.data.animal_base.province + '', response.data.animal_base.city + '', response.data.animal_base.district + '']
        }
        this.dialogFormVisible = true
        this.setRules()
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        baseinfo: {
          loan_type: 0
        },
        contact: [{}],
        animal: [{
          animal_type: '',
          animal_num: '',
          breeding_method: '',
          breeding_mode: [],
          small_female_num: '',
          male_num: '',
          small_num: '',
          efficiency: '',
          mortality_rate: '',
          is_insurance: 1,
          coverage: '',
          insurance_policy: '',
          is_prevent_epidemics: 1,
          pe_record: '',
          pe_certificate: '',
          trade_records: '',
          town_certificate: '',
          slaughter_time: '',
          animal_type_info: {},
          animal_female: [{ type: '', num: '' }]
        }],
        fodder: [{
          kind: [],
          childrenList: []
        }],
        animal_base: {
          address: ''
        },
        assets: { expenses: [{}] },
        space: {
          breeding_mode: []
        },
        loan: {
          loan_use: []
        },
        enterprise: {}
      }
      // this.activeName = 'fifth'
      this.activeName = 'third'
      const now = new Date()
      const year = now.getFullYear()
      this.first_year = (year - 1) + '年'
      this.second_year = (year - 2) + '年'
      this.address = []
    }

  }
}
</script>
<style scoped>
.el-divider--horizontal {
  margin: 35px 0;
}
.el-form-item .el-form-item{
  margin-bottom:22px;
}
.tabpane{
  padding:20px 0;
  height:70vh;
  overflow-y: scroll;
  scrollbar-width: none;
}
.footer{
  width:100%;
  display: flex;
  justify-content: center;
  padding-top:50px;
  position: absolute;
}
.shadow{
  width:100%;
  height:0;
  position: absolute;
  z-index:9999999999;
  top:0;left:-18px;
  border-top:2px solid rgb(231, 238, 228);
  background: rgb(92, 184, 53);
  box-shadow: 5px 0px 9px rgb(92, 184, 53);
}
.footer button{
  width:200px;
  margin:0 25px;
}
</style>
